// extracted by mini-css-extract-plugin
export var divider = "_ls-0";
export var systemMessage = "_ls-1";
export var systemMessageWrapper = "_ls-2";